import { decodeHTMLEntities } from 'components/horizontal-move-list/move-node/utils/decode-html-entities';

/**
 * Clean the comment text before saving it on the node property
 */
export function cleanCommentString(commentString: string | undefined): string | undefined {
  if (commentString === undefined) {
    return undefined;
  }

  let cleanedText: string;

  cleanedText = decodeHTMLEntities(stripHTMLTags(commentString));

  // Don't allow a standalone white space
  if (cleanedText === ' ') {
    cleanedText = '';
  }

  return cleanedText;
}

/**
 * strips HTML tags from a string
 */
function stripHTMLTags(str: string) {
  try {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    const value = doc.body.textContent;
    return value || '';
  } catch {
    // the above shouldn't ever throw, but just in case we'll destroy the comment rather than throwing in the move list.
    return '';
  }
}
